<div class="file-manager-status-center-intro-dialog">

  <div class="status-center-header">
    <div class="heading-label">{{ 'file-manager-status-center-heading-label' | xsI18n  }}</div>
    <span class="close-btn" (click)="closeStatusCenter()"></span>
  </div>

  <div class="status-button-row">
    <div class="status-button-row-item" [class.selected-button]="currentTemplate === inProgressTemplateRef"
      (click)="setStatusCenterTemplate('inProgressTemplate')">
      {{ 'file-manager-status-center-inprogress-button-label' | xsI18n  }}</div>
    <div class="status-button-row-item" [class.selected-button]="currentTemplate === doneTemplateRef"
      (click)="setStatusCenterTemplate('doneTemplate')">
      {{ 'file-manager-status-center-done-button-label' | xsI18n  }}</div>
    <div class="status-button-row-item" [class.selected-button]="currentTemplate === failedTemplateRef"
      (click)="setStatusCenterTemplate('failedTemplate')">
      {{ 'file-manager-status-center-failed-button-label' | xsI18n  }}</div>
  </div>

  <ng-container *ngTemplateOutlet="selectStatusCenterTemplate()"></ng-container>

  <ng-template #inProgressTemplate>
    <div class="template-div" (scroll)="onScroll()">
      <ng-container *ngIf="getStatusCenterDataByStatuses([contentStatusEnum.InProgress, contentStatusEnum.CompressInProgress]).length==0">
        <div class="no-updates-container">
          <div class="hd-icon hd-icon-alert icon-super-lg"></div>
          <div class="no-updates-text">{{ 'file-manager-status-center-no-new-updates' | xsI18n  }}</div>
        </div>
      </ng-container>
      <ng-container *ngIf="getStatusCenterDataByStatuses([contentStatusEnum.InProgress, contentStatusEnum.CompressInProgress]).length>0">
        <div class="template-action-card in-progress-card" *ngFor="let statusData of getStatusCenterDataByStatuses([contentStatusEnum.InProgress, contentStatusEnum.CompressInProgress])">
          <div class="action-card-data">
            <div class="in-progress-card-data first-row">
              <span class="hd-icon {{ getActionTypeIcon(statusData.actionType) }} icon-md first-item"></span>
              <span class="second-item">{{ getActionTypeText(statusData) }}</span>
              <span class="third-item" sa-ellipsis fullText={{statusData.file.name}}>{{ statusData.file.name }} </span>
            </div>
            <div class="in-progress-card-data second-row">
              <span [innerHTML]="getLocationText(statusData)"></span>
            </div>
            <mat-progress-bar value={{statusData.progress}} mode="{{getModeType(statusData)}}"> </mat-progress-bar>
            <div class="in-progress-card-data third-row">
              <span class='first-item' (click)="cancelAction(statusData)">{{
                ('xs_cancel_label' | xsI18n )}}</span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <ng-template #doneTemplate>
    <div class="template-div" (scroll)="onScroll()">
      <ng-container *ngIf="getStatusCenterData(contentStatusEnum.Done).length==0">
        <div class="no-updates-container">
          <div class="hd-icon hd-icon-alert icon-super-lg"></div>
          <div class="no-updates-text">{{ 'file-manager-status-center-no-new-updates' | xsI18n  }}</div>
        </div>
      </ng-container>
      <ng-container *ngIf="getStatusCenterData(contentStatusEnum.Done).length>0">
        <div class="dismiss-all-container">
          <div class="spacer"></div>
          <div class="dismiss-all-text" (click)="clearStatusCenterDataByContentStatus([contentStatusEnum.Done])">{{
            'file-manager-status-center-dismiss-all-text' | xsI18n  }}</div>
        </div>
      </ng-container>
      <ng-container *ngIf="getStatusCenterData(contentStatusEnum.Done).length>0">
        <div class="template-action-card done-card"
          *ngFor="let statusData of getStatusCenterDataSortedByCompletionDate([1])">
          <div class="action-card-data">
            <span class="hd-icon hd-icon-close icon-smd"
              (click)="deleteSingleRecordFromStatusCenter(statusData)"></span>
            <div class="done-card-data first-row">
              <span class="hd-icon hd-icon-selected icon-md"></span>
              <span class="first-item" sa-ellipsis [fullText]="getDoneDescription(statusData)">{{ getDoneDescription(statusData) }}</span>
              <span class="third-item">{{statusData.timeOfCompletion | date:'shortTime'}}</span>
            </div>
            <div class="done-card-data second-row">
              <span class="file-name" sa-ellipsis [fullText]="getStatusFileName(statusData)">{{ getStatusFileName(statusData) }}</span>
            </div>
            <div class="done-card-data third-row">
              <span [innerHTML]="getLocationText(statusData)"></span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <ng-template #failedTemplate>
    <div class="template-div" (scroll)="onScroll()">
      <ng-container
        *ngIf="getStatusCenterData(contentStatusEnum.Failed).length==0 && getStatusCenterData(contentStatusEnum.AwaitFeedback).length==0">
        <div class="no-updates-container">
          <div class="hd-icon hd-icon-alert icon-super-lg"></div>
          <div class="no-updates-text">{{ 'file-manager-status-center-no-new-updates' | xsI18n  }}</div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="getStatusCenterData(contentStatusEnum.Failed).length>0 || getStatusCenterData(contentStatusEnum.AwaitFeedback).length>0">
        <div class="dismiss-all-container">
          <div class="spacer"></div>
          <div class="dismiss-all-text"
            (click)="clearStatusCenterDataByContentStatus([contentStatusEnum.Failed, contentStatusEnum.AwaitFeedback])">
            {{ 'file-manager-status-center-dismiss-all-text' | xsI18n  }}</div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="getStatusCenterData(contentStatusEnum.Failed).length>0 || getStatusCenterData(contentStatusEnum.AwaitFeedback).length>0">
        <div class="template-action-card failed-card"
          *ngFor="let statusData of getStatusCenterDataSortedByCompletionDate([2,3])">
          <div class="action-card-data">
            <span class="hd-icon hd-icon-close icon-smd"
              (click)="deleteSingleRecordFromStatusCenter(statusData)"></span>
            <div class="failed-card-data first-row">
              <span class="first-item hd-icon hd-icon-error icon-md"></span>
              <span class="second-item" sa-ellipsis fullText={{statusData.file.name}}>{{
                statusData.file.name }}</span>
              <span class="third-item">{{statusData.timeOfCompletion | date:'shortTime'}}</span>
            </div>
            <div class="failed-card-data second-row">
              <span [innerHTML]="getLocationText(statusData)"></span>
            </div>
            <div class="failed-card-data third-row">
              <span> {{getErrorMessage(statusData.actionType,statusData.error) }}</span>
            </div>
            <div class="failed-card-data fourth-row"
              *ngIf="statusData.contentStatus == contentStatusEnum.AwaitFeedback">
              <span class="first-item" (click)="overwriteAction(statusData)">{{
                ('file-manager-status-center-failed-overwrite-text' | xsI18n )}}</span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>
